<mat-toolbar class="mat-typography toolbar" *ngIf="!media.isActive('xs')">
    <mat-toolbar-row fxLayout="row wrap" fxLayout.xs="column" [ngClass]="{
    'toolbar-row-top': media.isActive('gt-xs'),
    'xxtoolbar-row-top-xs': media.isActive('1xs') && !isNavigationTwoRows,
    'xxtoolbar-row-top-two-rows-xs': media.isActive('xs') && isNavigationTwoRows
  }">
        <a class="main-toolbar-link">
            <span class="toolbar-logo-container"> <img src="{{ getLogoUrl() }}" class="toolbar-logo" alt="Logo" />
            </span>
        </a>
        <span class="toolbar-title flex-spacer primary-color" *ngIf="navigationOptions.titles.displayBlank"></span>
        <span class="toolbar-title flex-spacer primary-color" *ngIf="navigationOptions.titles.displayAuthentication"
            i18n="@@page-header.page-title.authentication">page-header.page-title.authentication</span>
        <span class="toolbar-title flex-spacer primary-color"
            *ngIf="navigationOptions.titles.displayAuthenticationForgotUsername"
            i18n="@@page-header.page-title.authentication-forgot-username">page-header.page-title.authentication-forgot-username</span>
        <span class="toolbar-title flex-spacer primary-color"
            *ngIf="navigationOptions.titles.displayAuthenticationForgotPassword"
            i18n="@@page-header.page-title.authentication-forgot-password">page-header.page-title.authentication-forgot-password</span>
        <span class="toolbar-title flex-spacer primary-color reg" *ngIf="navigationOptions.titles.displayRegistration"
            i18n="@@page-header.page-title.registration">page-header.page-title.registration</span>
        <span class="toolbar-title flex-spacer primary-color mfa"
            *ngIf="navigationOptions.titles.displayMultifactorVerify"
            i18n="@@page-header.page-title.multifactor-verify">page-header.page-title.multifactor-verify</span>
        <span class="toolbar-title flex-spacer primary-color" *ngIf="navigationOptions.titles.displaySecurityQuestion"
            i18n="@@page-header.page-title.security-question">page-header.page-title.security-question</span>
        <button mat-button class="toolbar-button" *ngIf="navigationOptions.menuOptions.displayHome"
            (click)="openHome()">
            <mat-icon class="toolbar-button-icon">home</mat-icon>
        </button>
        <button mat-button class="toolbar-button"
            [ngClass]="{ 'primary-lightest-bg-important': isSelectedButton('QUICKPAY') }"
            *ngIf="navigationOptions.menuOptions.displayQuickPayLogin" (click)="openQuickPayLogin()"
            i18n="@@page-header.quick-pay">
            page-header.quick-pay
        </button>
        <button mat-button class="toolbar-button"
            [ngClass]="{ 'primary-lightest-bg-important': isSelectedButton('CONTACTUS') }"
            *ngIf="navigationOptions.menuOptions.displayContactUs" (click)="openContactUs()"
            i18n="@@page-header.contact-us">
            page-header.contact-us
        </button>
        <button mat-button class="toolbar-button" *ngIf="navigationOptions.menuOptions.displayLogin" (click)="login()"
            i18n="@@page-header.login">
            page-header.login
        </button>
        <button mat-button class="toolbar-button" *ngIf="navigationOptions.menuOptions.displayLogout" (click)="logout()"
            i18n="@@page-header.logout">
            page-header.logout
        </button>
    </mat-toolbar-row>
    <mat-toolbar-row fxLayout="row wrap" fxLayout.xs="column" [ngClass]="{
      'toolbar-row-bottom': media.isActive('gt-xs'),
      'xxtoolbar-row-bottom-xs': media.isActive('xs')
    }" *ngIf="isNavigationTwoRows">
        <button mat-button class="toolbar-button"
            [ngClass]="{ 'primary-lightest-bg-important': isSelectedButton('Profile') }"
            *ngIf="navigationOptions.menuOptions.displayProfile && !isSelectedButton('QUICKPAY')"
            (click)="openProfile()">
            <mat-icon class="toolbar-button-icon"
                *ngIf="media.isActive('gt-sm') || (media.isActive('lt-md') && !navigationOptions.menuOptions.displayMilitaryBenefits)">person</mat-icon><span
                i18n="@@page-header.account-info">page-header.account-info</span>
        </button>
        <button mat-button [matMenuTriggerFor]="loanDetailsMenu" class="toolbar-button"
            [ngClass]="{ 'primary-lightest-bg-important': isSelectedButton('LoanDetails') }"
            *ngIf="navigationOptions.menuOptions.displayLoanDetails && !isSelectedButton('QUICKPAY')">
            <mat-icon class="toolbar-button-icon"
                *ngIf="media.isActive('gt-sm') || (media.isActive('lt-md') && !navigationOptions.menuOptions.displayMilitaryBenefits)">list</mat-icon><span
                i18n="@@page-header.loan-details">page-header.loan-details</span><mat-icon
                class="toolbar-button-icon light-display-text">keyboard_arrow_down</mat-icon>
        </button>
        <button mat-button [matMenuTriggerFor]="paymentsMenu" #paymentsMenuTrigger="matMenuTrigger"
            (click)="paymentsMenuTrigger.openMenu()" class="toolbar-button"
            [ngClass]="{ 'primary-lightest-bg-important': isSelectedButton('Payments') }"
            *ngIf="navigationOptions.menuOptions.displayPayments && !isSelectedButton('QUICKPAY')">
            <mat-icon class="toolbar-button-icon"
                *ngIf="media.isActive('gt-sm') || (media.isActive('lt-md') && !navigationOptions.menuOptions.displayMilitaryBenefits)">attach_money</mat-icon><span
                i18n="@@page-header.payments">page-header.payments</span><mat-icon
                class="toolbar-button-icon light-display-text">keyboard_arrow_down</mat-icon>
        </button>
        <span class="flex-spacer"></span>
        <button mat-button class="toolbar-button" *ngIf="navigationOptions.menuOptions.displayMilitaryBenefits"
            (click)="openMilitaryBenefits()">
            <mat-icon class="toolbar-button-icon" *ngIf="media.isActive('gt-sm')">outlined_flag</mat-icon><span
                i18n="@@page-header.military-benefits">page-header.military-benefits</span>
        </button>
        <button mat-button class="toolbar-button"
            [ngClass]="{ 'primary-lightest-bg-important': isSelectedButton('FAQ') }"
            *ngIf="navigationOptions.menuOptions.displayFAQ && !isSelectedButton('QUICKPAY')" (click)="openFAQ()">
            <mat-icon class="toolbar-button-icon"
                *ngIf="media.isActive('gt-sm') || (media.isActive('lt-md') && !navigationOptions.menuOptions.displayMilitaryBenefits)">help_outline</mat-icon><span
                i18n="@@page-header.faq">page-header.faq</span>
        </button>
        <button mat-button class="toolbar-button"
            [ngClass]="{ 'primary-lightest-bg-important': isSelectedButton('Resources') }"
            *ngIf="navigationOptions.menuOptions.displayResources" (click)="openResources()">
            <mat-icon class="toolbar-button-icon"
                *ngIf="media.isActive('gt-sm') || (media.isActive('lt-md') && !navigationOptions.menuOptions.displayMilitaryBenefits)">info</mat-icon><span
                i18n="@@page-header.resources">page-header.resources</span>
        </button>
        <mat-menu #loanDetailsMenu="matMenu" [overlapTrigger]="false">
            <button mat-menu-item (click)="openLoanDetails()" i18n="@@page-header.loan-details.loan-details">
                page-header.loan-details.loan-details
            </button>
            <button mat-menu-item (click)="openESign()"
                i18n="@@page-header.loan-details.e-sign">page-header.loan-details.e-sign</button>
        </mat-menu>
        <mat-menu #paymentsMenu="matMenu" [overlapTrigger]="false">
            <button mat-menu-item (click)="openPayNow()"
                i18n="@@page-header.payments.pay-now">page-header.payments.pay-now</button>
            <button mat-menu-item (click)="openTransactionHistory()" i18n="@@page-header.payments.payment-history">
                page-header.payments.payment-history
            </button>
            <button mat-menu-item (click)="openSetupCancelAutoPay()"
                i18n="@@page-header.payments.setup-cancel-auto-pay">
                page-header.payments.setup-cancel-auto-pay
            </button>
        </mat-menu>
    </mat-toolbar-row>
</mat-toolbar>

<!-- Main toolbar (outside the drawer) -->
<mat-toolbar class="mat-typography toolbar" *ngIf="media.isActive('xs')">
    <button mat-icon-button (click)="drawer.toggle()" class="hamburger-button branded-button" *ngIf="isLoggedIn()">
        <mat-icon>menu</mat-icon>
    </button>
    <div class="drawer-logo-container" (click)="openHome()">
        <img [src]="getLogoUrl()" alt="Logo" class="drawer-logo" />
    </div>
    <span class="spacer"></span>
    <button mat-button class="toolbar-button"
        [ngClass]="{ 'primary-lightest-bg-important': isSelectedButton('QUICKPAY') }"
        *ngIf="navigationOptions.menuOptions.displayQuickPayLogin"
        (click)="openQuickPayLogin()"
        i18n="@@page-header.quick-pay">
        page-header.quick-pay
    </button>
    <button mat-button class="toolbar-button"
        [ngClass]="{ 'primary-lightest-bg-important': isSelectedButton('CONTACTUS') }"
        *ngIf="navigationOptions.menuOptions.displayContactUs" (click)="openContactUs()"
        i18n="@@page-header.contact-us">
        page-header.contact-us
    </button>
    <!-- <button mat-button class="toolbar-button" *ngIf="navigationOptions.menuOptions.displayLogin" (click)="login()"
        i18n="@@page-header.login">
        page-header.login
    </button> -->
</mat-toolbar>

<mat-drawer #drawer class="av-sidenav" mode="over">
    <!-- Header area with logo & close button (mobile) -->
    <div class="drawer-header" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="drawer-logo-container">
            <img [src]="getLogoUrl()" alt="Logo" class="drawer-logo" />
        </div>
        <button mat-icon-button (click)="drawer.close()" class="close-button branded-button" *ngIf="media.isActive('xs')">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Main navigation list with blue text/icons -->
    <mat-nav-list class="blue-menu">
        <!-- Home -->
        <mat-list-item
            (click)="openHome(); setActiveItem('HOME');drawer.close()"
            [ngClass]="{'active-item': activeItem === 'HOME'}"
            *ngIf="navigationOptions.menuOptions.displayHome">
            <mat-icon matListIcon>home</mat-icon>
            <div matLine>Home</div>
        </mat-list-item>
        <!-- <mat-divider class="drawer-menu-divider"></mat-divider> -->
        <!-- Profile -->
        <mat-list-item (click)="openProfile(); setActiveItem('profile'); drawer.close()"
            [ngClass]="{'active-item': activeItem === 'profile'}"
            *ngIf="navigationOptions.menuOptions.displayProfile && !isSelectedButton('QUICKPAY')">
            <mat-icon matListIcon>person</mat-icon>
            <div matLine i18n="@@page-header.account-info">page-header.account-info</div>
        </mat-list-item>
        <!-- Loan Details (collapsible) -->
        <mat-list-item (click)="toggleLoanDetails()">
            <mat-icon matListIcon>list</mat-icon>
            <div matLine i18n="@@page-header.loan-details">page-header.loan-details</div>
            <mat-icon matSuffix>{{ showLoanDetails ? 'expand_more' : 'chevron_right' }}</mat-icon>
        </mat-list-item>
        <!-- Sub-items -->
        <ng-container *ngIf="showLoanDetails">
            <mat-list-item class="sub-list-item" 
                [ngClass]="{'active-item': activeItem === 'loanDetails'}"
                (click)="openLoanDetails(); setActiveItem('loanDetails'); drawer.close()">
                <div class="sub-list-item-contents" matLine i18n="@@page-header.loan-details">page-header.loan-details</div>
            </mat-list-item>
            <mat-list-item class="sub-list-item" [ngClass]="{'active-item': activeItem === 'eSign'}"
                (click)="openESign(); setActiveItem('eSign'); drawer.close()">
                <div class="sub-list-item-contents" matLine i18n="@@page-header.loan-details.e-sign">page-header.loan-details.e-sign</div>
            </mat-list-item>
        </ng-container>
        <!-- Payments (collapsible) -->
        <mat-list-item (click)="togglePayments()">
            <mat-icon matListIcon>attach_money</mat-icon>
            <div matLine i18n="@@page-header.payments">page-header.payments</div>
            <mat-icon matSuffix>{{ showPayments ? 'expand_more' : 'chevron_right' }}</mat-icon>
        </mat-list-item>
        <!-- Sub-items -->
        <ng-container *ngIf="showPayments">
            <mat-list-item class="sub-list-item" [ngClass]="{'active-item': activeItem === 'payNow'}"
                (click)="openPayNow(); setActiveItem('payNow'); drawer.close()">
                <div class="sub-list-item-contents" matLine i18n="@@page-header.payments.pay-now">page-header.payments.pay-now<</div>
            </mat-list-item>
            <mat-list-item class="sub-list-item" [ngClass]="{'active-item': activeItem === 'paymentHistory'}"
                (click)="openTransactionHistory(); setActiveItem('paymentHistory'); drawer.close()">
                <div class="sub-list-item-contents" i18n="@@page-header.payments.payment-history" matLine>page-header.payments.payment-history</div>
            </mat-list-item>
            <mat-list-item class="sub-list-item" [ngClass]="{'active-item': activeItem === 'autoPay'}"
                (click)="openSetupCancelAutoPay(); setActiveItem('autoPay'); drawer.close()">
                <div class="sub-list-item-contents" matLine i18n="@@page-header.payments.setup-cancel-auto-pay">
                    page-header.payments.setup-cancel-auto-pay</div>
            </mat-list-item>
        </ng-container>

        <!-- Divider -->
        <mat-divider class="drawer-menu-divider"></mat-divider>

        <!-- FAQ -->
        <mat-list-item (click)="openFAQ(); setActiveItem('FAQ');drawer.close()"
            [ngClass]="{'active-item': activeItem === 'FAQ'}">
            <mat-icon matListIcon>help_outline</mat-icon>
            <div matLine i18n="@@page-header.faq">page-header.faq</div>
        </mat-list-item>

        <!-- Need Help? -->
        <mat-list-item (click)="openResources(); setActiveItem('RESOURCES');drawer.close()"
            [ngClass]="{'active-item': activeItem === 'RESOURCES'}">            
            <mat-icon matListIcon>info</mat-icon>
            <div matLine i18n="@@page-header.resources">page-header.resources</div>
        </mat-list-item>

        <!-- Logout -->
        <mat-list-item (click)="logout(); drawer.close()">
            <mat-icon matListIcon>exit_to_app</mat-icon>
            <div matLine i18n="@@page-header.logout">
                page-header.logout</div>
        </mat-list-item>
    </mat-nav-list>
</mat-drawer>